import { forwardRef } from 'react';

import {
  ContainerFooter,
  type ContainerFooterProps,
} from '@frontend/legacy-components';

export type PaneFooterProps = ContainerFooterProps;

export const PaneFooter = forwardRef<HTMLParagraphElement, PaneFooterProps>(
  (props, ref) => <ContainerFooter ref={ref} px={2} {...props} />,
);

PaneFooter.displayName = 'PaneFooter';
